import http from '../../http'

const getAllCluster = (partner) => http.get(`cluster/segments?filter[0][field]=partner&filter[0][operator]=in&filter[0][value][0]=${partner}&filter[0][value][1]=null`)

const getSegmentations = (partner) => http.get(`https://cluster-api-dev.seedz.ag/api/v1/segments?filter[0][field]=partner&filter[0][operator]=in&filter[0][value][0]=${partner}`)

const getSegmentationsByPartner = (partner) => http.get(`https://cluster-api-dev.seedz.ag/api/v1/segments?filter[0][field]=partnerSelect&filter[0][operator]=in&filter[0][value][0]=${partner}`)

export {
  getAllCluster,
  getSegmentations,
  getSegmentationsByPartner
}
